import Service from '@/service/cdn_config'

const Data = {
    metro_lines: []
}

export default {
    async getMetroLines () {
        if (Data.metro_lines.length) {
            return Promise.resolve(Data.metro_lines)
        }
        const { lines } = await Service.getMetroLines()
        Data.metro_lines = lines
        return lines
    }
}